<template>
    <div style="height: 100%;">
      <div class="spin">
        <div
          style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"
        >
          <div>
            <img
              src="../assets/images/logo2.png"
              loading="lazy"
              style="height:100px;"
            />
          </div>
          <div
            style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;"
          >
            <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
          </div>
        </div>
        <div
          style="position: absolute; top: 60px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
        <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              :options="defaultOptionsHue"
              :height="250"
              :width="250"
              v-on:animCreated="handleAnimationHue"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              :options="defaultOptionsKoy"
              :height="250"
              :width="250"
              v-on:animCreated="handleAnimationKoy"
            />
          </div>
        <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
          <img src="../assets/images/huekoy/main_00090.png" :style="{'display':showImage}">
          </div>
          
        </div>
        <div
          :style="{
            position: 'absolute',
            top: '200px',
            'align-items': 'center',
            'justify-content': 'center',
            display: 'flex',
            left: '0',
            right: '0',
            display: showResult ? 'block' : 'none'
          }"
        >
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: win,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsWin" :height="550" :width="550"  v-on:animCreated="handleAnimationWin" /> -->
            <img src="../assets/images/win.png" />
          </div>
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: lose,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsLose" :height="550" :width="550"  v-on:animCreated="handleAnimationLose" /> -->
            <img src="../assets/images/lose.png" />
          </div>
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: draw,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsDraw" :height="550" :width="550"  v-on:animCreated="handleAnimationDraw" /> -->
            <img src="../assets/images/draw.png" />
          </div>
        </div>
        <div
          style="position: absolute; bottom: 80px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <div
            style="display: flex; flex: 1; align-items: center; justify-content: center;"
          >
            <div style="cursor: pointer;">
              <img
                src="../assets/images/huekoy/HKK_2_0.png"
                width="124"
                @click="select('hue')"
              />
            </div>
            <div style="cursor: pointer;">
              <img
                src="../assets/images/huekoy/HKK_3_0.png"
                width="124"
                @click="select('koy')"
              />
            </div>
          </div>
        </div>
        <div
          style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <div
            style="display: flex; flex: 1; align-items: center; justify-content: center;"
          >
            <div
              style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;"
            >
              <span class="glow" ref="myBtn">
                {{ loadingtext }}
              </span>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </template>
  
  <script>
  import firebase, { firestore } from "firebase/app";
  import "firebase/database";
  import moment from "moment-timezone";
  import router from "./../router";
  import Lottie from "./lottie.vue";
  import { loadAnimation } from "@/services/lottieLoader";
  import liffService from "@/services/liff";
  // import * as animationWin from '../assets/win-game.json';
  // import * as animationLose from '../assets/lose-game.json';
  // import * as animationDraw from '../assets/draw-game.json';
  export default {
    name: "S1",
    async created() {
      const [animage, animage2] = await Promise.all([
        loadAnimation('images/huekoy/HUR'),
        loadAnimation('images/huekoy/KOY')
      ]);
      this.defaultOptionsHue = {
        animationData: animage,
        autoplay: false,
        loop: false
      };
      this.defaultOptionsKoy = {
        animationData: animage2,
        autoplay: false,
        loop: false
      };
  
      // const animagewin = animationWin.default;
      // this.defaultOptionsWin = {animationData: animagewin,autoplay:false,loop:false};
  
      // const animagelose = animationLose.default;
      // this.defaultOptionsLose = {animationData: animagelose,autoplay:false,loop:false};
  
      // const animagedraw = animationDraw.default;
      // this.defaultOptionsDraw = {animationData: animagedraw,autoplay:false,loop:false};
      // this.animWin.hide()
      // this.animLose.hide()
      // this.animDraw.hide()
    },
    components: {
      lottie: Lottie
    },
    data() {
      return {
        win: "none",
        lose: "none",
        draw: "none",
        showResult: false,
        pictureUrl: "",
        mycoin: 0,
        showLoading: true,
        isDisabled: true,
        percentage: 0,
        canOpen: false,
        loadingtext: "น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่",
        showImage: "block",
      };
    },
    mounted() {
      //   this.anim.play();
      // LIFF is already initialized by router guard
      this.loadUserData();
      //   setTimeout(() => {
      //     this.showLoading = false;
      //     this.anim.stop()
      //     setTimeout(() => {
      //       this.animempty1.hide()
      //       this.animempty2.hide()
      //       this.animempty3.hide()
      //       this.animpoint1.hide()
      //       this.animpoint2.hide()
      //       this.animpoint3.hide()
      //       this.anim1.play()
      //       this.anim2.play()
      //       this.anim3.play()
      //     }, 500)
      //   }, 2500);
    },
    methods: {
      select(select) {
        if (this.canOpen) {
          this.$confirm({
            message: `ยืนยันการเลือก${
              select === "hue" ? "หัว" : "ก้อย"
            }?`,
            button: {
              yes: "OK",
              no: "Cancel"
            },
            callback: async confirm => {
              if (confirm) {
                this.canOpen = false;
                const com = Math.floor(Math.random() * 2);
                let select2 = "";
                console.log(com);
                if (com === 0) {
                  select2 = "hue";
                  this.showImage = "none";
                  this.animKoy.hide();
                  this.animHue.play();
                } else {
                  select2 = "koy";
                  this.showImage = "none";
                  this.animKoy.play();
                  this.animHue.hide();
                } 
  
                
                console.log(select2 + "==" + select);
                if (select2 === select) {
                  console.log("win");
                  const item = 40;
                  setTimeout(() => {
                    this.showResult = true;
                    this.win = "flex";
                    this.lose = "none";
                    this.draw = "none";
                    // this.animWin.play()
                    // this.animDraw.hide()
                    // this.animLose.hide()
                    firebase
                      .firestore()
                      .collection("scratch")
                      .doc(
                        this.userId +
                          "-" +
                          moment()
                            .tz("Asia/Bangkok")
                            .format("YYYY-MM-DD")
                      )
                      .set({
                        userId: this.userId,
                        createdate: moment()
                          .tz("Asia/Bangkok")
                          .format("YYYY-MM-DD HH:mm:ss"),
                        spin: Number(item),
                        value: Number(item)
                      });
                    setTimeout(() => {
                      this.$confirm({
                        message: `✌️ ปังปุรีเย่!! คุณได้รับ ${item} เหรียญ😘😘`,
                        button: {
                          yes: "OK"
                        },
                        callback: async confirm => {
                          if (confirm) {
                            this.sendMessageLine3(item + " เหรียญ");
                          }
                        }
                      });
                    }, 2000);
                  }, 3000);
                } else{
                    setTimeout(() => {
                    this.showResult = true;
                    this.win = "none";
                    this.lose = "flex";
                    this.draw = "none";
                    firebase
                      .firestore()
                      .collection("scratch")
                      .doc(
                        this.userId +
                          "-" +
                          moment()
                            .tz("Asia/Bangkok")
                            .format("YYYY-MM-DD")
                      )
                      .set({
                        userId: this.userId,
                        createdate: moment()
                          .tz("Asia/Bangkok")
                          .format("YYYY-MM-DD HH:mm:ss"),
                        spin: 0,
                        value: 0
                      });
                    setTimeout(() => {
                      this.sendMessageLine(`คุณแพ้เสียใจด้วยนะจ๊ะ 😭`);
                    }, 2000);
                    // this.animLose.play()
                    // this.animWin.hide()
                    // this.animDraw.hide()
                  }, 3000);
                }
              }
            }
          });
        }
      },
      handleAnimationHue: function(anim) {
        this.animHue = anim;
      },
      handleAnimationKoy: function(anim) {
        this.animKoy = anim;
      },
      
      // handleAnimationWin: function (anim) {
      //   this.animWin = anim
      // },
      // handleAnimationLose: function (anim) {
      //   this.animLose = anim
      // },
      // handleAnimationDraw: function (anim) {
      //   this.animDraw = anim
      // },
      async sendMessageLine(text) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: "✌️ " + text
          }
        ]);
        window.liff.closeWindow();
      },
      async sendMessageLine2(text) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: "✌️ " + text
          }
        ]);
      },
      async sendMessageLine3(text) {
        await window.liff.sendMessages([
          {
            type: "flex",
            altText: "ปังปุรีเย่!! คุณได้รับ " + text,
            contents: {
              type: "bubble",
              size: "micro",
              body: {
                type: "box",
                layout: "vertical",
                contents: [
                  {
                    type: "text",
                    text: "ยินดีด้วยค่ะ !",
                    color: "#CCCCCC",
                    size: "lg",
                    weight: "bold",
                    align: "center"
                  },
                  {
                    type: "image",
                    url:
                      "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                    position: "relative",
                    size: "sm"
                  },
                  {
                    type: "text",
                    text: "+" + text,
                    size: "sm",
                    color: "#CCCCCC",
                    align: "center",
                    weight: "bold"
                  }
                ],
                spacing: "xxl",
                margin: "none",
                action: {
                  type: "uri",
                  label: "action",
                  uri: "https://liff.line.me/2006378234-72e9GVNa/reward",
                  altUri: {
                    desktop: "https://liff.line.me/2006378234-72e9GVNa/reward"
                  }
                },
                background: {
                  type: "linearGradient",
                  angle: "0deg",
                  startColor: "#DD2476",
                  endColor: "#FF512F"
                }
              },
              styles: {
                footer: {
                  separator: true
                }
              }
            }
          }
        ]);
        window.liff.closeWindow();
      },
      async loadUserData() {
        // Get profile from centralized service (already fetched by router guard)
        const profile = liffService.profile;
        if (!profile) return;

        this.userId = profile.userId || "";
        this.pictureUrl = profile.pictureUrl || "none";
        if (this.userId) {
            const user = (
              await firebase
                .database()
                .ref(`/users`)
                .orderByChild("userId")
                .equalTo(this.userId)
                .once("value")
            ).val();
            if (user) {
              const u = user[Object.keys(user)[0]];
              this.mycoin = u.coins ? u.coins : 0;
              this.userKey = Object.keys(user)[0];
              this.sendMessageLine2(
                "สนใจเล่นหัวก้อย พลอยใสจัดการให้หน่อย 😘😘"
              );
              if (moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === "2026-03-25") {
                await firebase
                  .firestore()
                  .collection("scratch")
                  .doc(this.userId +"-" +moment().tz("Asia/Bangkok").format("YYYY-MM-DD"))
                  .get()
                  .then(async snapshot => {
                    if (snapshot.exists) {
                      this.sendMessageLine(
                        "ลูกค้าเล่นหัวก้อยไปแล้วนะคะวันนี้ รอวันใหม่นะคะ 😘😘"
                      );
                    } else {
                      await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                      //  await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                        let credit = 0;
                        snapshot.forEach((doc)=>{
                          credit += Number(doc.data().qty);
                        });
                        if(credit >= 500){
                          this.loadingtext = 'น้องออโต้พร้อมแล้วเล่นหัวก้อย ได้เลยค่ะ😘😘';
                          this.showLoading = true;
                          this.canOpen= true;
                        }else{
                          const less = 500-Number(credit);
                          this.loadingtext = `เติมเงินอีก ${less}(500) ได้เล่นเลยค่ะ!😘😘`;
                          //this.loadingtext = `มียอดฝากวันนี้ได้เล่นเลยค่ะ!😘😘`;
                        }
                      });
                    }
                  });
              } else {
                this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 25 March เท่านั้น!😘😘`;
              }
            } else {
              router.replace("/register");
            }
          this.isDisabled = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .wrapper {
    padding-left: 20%;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    padding-top: 50%;
    height: 100%;
  }
  .glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
  }
  
  @-webkit-keyframes glow {
    from {
      text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
        0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
  
    to {
      text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
        0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
  }
  .spin {
    padding: 0px;
    margin: 0px;
    overflow: hidden;
    height: 100%;
    /*background: rgb(255,204,92,1);
      background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
    background: linear-gradient(rgb(0, 0, 0), rgb(0, 0, 0));
    border-right: 2px solid #cbcbcb;
    background-size: 100% auto;
    background-position: center top;
    background-attachment: fixed;
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
  }
  </style>
  